<template>
  <div class="login-container" :style="{backgroundImage:'url(' + img1 + ')' }">
    <top-color v-show="false"></top-color>
    <div class="login-weaper animated bounceInDown">
      <div class="login-left" :style="{backgroundImage:'url(' + img + ')' }">
        <!-- <div class="login-time">
          {{website.indexTitle}}
        </div> -->
        <!-- <img class="img" src="/img/logo.png" alt=""> -->
        <p class="login-name">{{time}}</p>
        <p class="login-beianhao">备案号：<a style="background-color: aliceblue;" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备09069521号-1</a></p>
      </div>
      <div class="login-border">
        <div class="login-main">
          <h4 class="login-title">
            <!-- 登录 -->
            <img class="img" :src="imageUrl" alt="" style="width: 180px;height: 80px;"> <br/>
            {{website.indexTitle}}
            <!-- {{website.title}} -->
          </h4>
          <userLogin v-if="activeName==='user'"></userLogin>
          <codeLogin v-else-if="activeName==='code'"></codeLogin>
          <thirdLogin v-else-if="activeName==='third'"></thirdLogin>
          <!-- 第三方登录 -->
          <!-- <div class="login-menu">
            <a href="#" @click.stop="activeName='user'">账号密码登录</a>
            <a href="#" @click.stop="activeName='code'">手机号登录</a>
            <a href="#" @click.stop="activeName='third'">第三方系统登录</a>
          </div> -->
        </div>
      </div>
    </div>
    <p class="reference" v-if="userRule.xfjdbah" v-text="userRule.xfjdbah" @click="referClick"></p>
  </div>
</template>
<script>
import userLogin from "./userlogin";
import codeLogin from "./codelogin";
import thirdLogin from "./thirdlogin";
import {mapGetters} from "vuex";
import {dateFormat} from "@/util/date";
import {validatenull} from "@/util/validate";
import topColor from "@/page/index/top/top-color";
import {getQueryString, getTopUrl,urlToObj} from "@/util/util";
import {getRunId} from '@/api/table/table';
import img from "@/assets/login1.png";
import img1 from "@/assets/bluebgc.jpg";

  export default {
    computed: {
      ...mapGetters(["website", "tagWel","userRule"])
    },
    name: "login",
    components: {
      userLogin,
      codeLogin,
      thirdLogin,
      topColor
    },
    data() {
      return {
        img:img,
        img1:img1,
        time: "",
        activeName: "user",
        socialForm: {
          tenantId: "000000",
          source: "",
          code: "",
          state: "",
        },
        imageUrl:require("@/assets/HYNTlogo.png")
      };
    },
    watch: {
      $route() {
        this.handleLogin();
      }
    },
    created() {
      this.handleLogin();
      this.getTime();
    },
    mounted() {},
    props: [],
    methods: {
      // 备案点击
      referClick() {
        window.open(this.userRule.xfjdbadz,"_blank");
      },
      getTime() {
        this.$store.commit("SET_AddRouter",false);//清空 是否添加了动态路由状态置为 否
        setInterval(() => {
          this.time = dateFormat(new Date());
        }, 1000);
      },
      // 验证
      getTenant() {
        let url = window.location.href;
        let arr = url.match(/\?(\S*)#/);
        let arr2 = url.split("/#/login?");
        if(arr&&arr.length>0){
          let obj=urlToObj(arr[1]);
          console.log(obj);
          if(obj.ticket){
            this.thirdPartyLogin({
              grant_type:"captcha",
              scope: 'all',
              AUTH_URL:obj.path?obj.MODULE_ID?decodeURIComponent(obj.path)+"?MODULE_ID="+obj.MODULE_ID:decodeURIComponent(obj.path):"",
            },{
              ...obj,
              callbackUrl:obj.path?decodeURIComponent(obj.path):"",
            });
          }else{
            window.open(this.website.loginWebsite,"_self");
          }
        }
        if(arr2&&arr2.length>0){
          let obj=urlToObj(arr2[1]);
          // 跳转其他系统进入
          if(obj.type==1){
            this.thirdPartyLogin({
              username: obj.user||'',
              p: obj.p||'',
              type: "account",
              grant_type: "captcha",
              tenantId: "000000",
              scope: "all",
              loginType:obj.loginType, // 自己跳自己时需要传
              AUTH_URL:obj.path?obj.MODULE_ID?decodeURIComponent(obj.path)+"?MODULE_ID="+obj.MODULE_ID:decodeURIComponent(obj.path):"",
            },{
              "Tenant-Id":"000000",
              callbackUrl:decodeURIComponent(obj.path),
            });
          }else if(obj.ticket){
            this.thirdPartyLogin({
              grant_type:"captcha",
              scope: 'all',
              AUTH_URL:obj.path?obj.MODULE_ID?decodeURIComponent(obj.path)+"?MODULE_ID="+obj.MODULE_ID:decodeURIComponent(obj.path):"",
            },{
              ...obj,
              callbackUrl:decodeURIComponent(obj.path),
            });
          }
        }
        // 临时指定域名，方便测试
        // 租户信息
        // info(domain).then(res => {
        //   const data = res.data;
        //   if (data.success && data.data.tenantId) {
        //     this.tenantMode = false;
        //     this.form.tenantId = data.data.tenantId;
        //     this.$parent.$refs.login.style.backgroundImage = `url(${data.data.backgroundUrl})`;
        //   }
        // })
      },
      // 第三方系统登录
      thirdPartyLogin(params,head){
        const loading = this.$loading({
          lock: true,
          text: '第三方系统登录中,请稍后。。。',
          spinner: "el-icon-loading"
        });
        this.$store.dispatch("LoginByUsername", {params,head}).then((res) => {
            // console.log(this.$route);
            // console.log(this.tagWel);
            this.$store.dispatch("LoginObj", this.$route.query)
            this.$router.push({
              path:head.callbackUrl||this.tagWel.value,
              query:{
                MODULE_ID: head.MODULE_ID,
                ...this.$route.query,
              }
            });
            loading.close();
          // }
        }).catch((e) => {
          window.console.log(e);
          debugger;
          loading.close();
          // alert(e.toString().replace("Error: ",""));
          // window.open(e.toString().replace("Error: ",""),"_self");
          // window.open(this.website.loginWebsite,"_self");
          window.opener=null;
          window.open('',self);
          window.close();
        });
      },
      handleLogin() {
        this.getTenant();
        // const topUrl = getTopUrl();
        // const redirectUrl = "/oauth/redirect/";
        // this.socialForm.source = getQueryString("source");
        // this.socialForm.code = getQueryString("code");
        // this.socialForm.state = getQueryString("state");
        // if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
        //   let source = topUrl.split("?")[0];
        //   source = source.split(redirectUrl)[1];
        //   this.socialForm.source = source;
        // }
        // if (!validatenull(this.socialForm.source) && !validatenull(this.socialForm.code) && !validatenull(this.socialForm.state)) {
        //   const loading = this.$loading({
        //     lock: true,
        //     text: '第三方系统登录中,请稍后。。。',
        //     spinner: "el-icon-loading"
        //   });
        //   this.$store.dispatch("LoginBySocial", this.socialForm).then(() => {
        //     window.location.href = topUrl.split(redirectUrl)[0];
        //     this.$router.push({path: this.tagWel.value});
        //     loading.close();
        //   }).catch(() => {
        //     loading.close();
        //   });
        // }
      }
    }
  };
</script>

<style lang="scss">
  @import "@/styles/login.scss";
</style>
<style lang="scss" scoped>
  .login-name{
    position: absolute;
    bottom: 38px;
    left: 0px;
    right: 0px;
    // margin-top: 350px;
    text-align: center;
    font-size: 25px;
    // font-weight: bolder;
  }
  .login-beianhao{
    position: absolute;
    bottom: 10px;
    left: 0px;
    right: 0px;
    // margin-top: 350px;
    text-align: center;
    font-size: 15px;
    // font-weight: bolder;
  }
  .login-left{
    // background: url("~@/assets/login1.jpg");
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .reference{
    position: fixed;
    bottom: 20px;
    left: 50%;
    width: 250px;
    margin-left: -125px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    &:hover{
      text-decoration:underline;
    }
  }
</style>
